/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import type { CSSProperties } from "react";
import { ManateeMark } from "../components/ui/ManateeMark";
import { useChrome } from "../contexts/ChromeContext";

/**
 * Shared empty-state for routes that are scaffolded but not yet built. Keeps the unified shell
 * legible while each surface is filled in — the title sets the chrome header so the frame reads
 * correctly as you click through the navigation.
 */
export function Placeholder({
  title,
  description,
  milestone,
}: {
  title: string;
  description?: string;
  milestone?: string;
}) {
  useChrome({ title }, [title]);
  return (
    <div className="grid h-full place-items-center">
      <div
        className="enter flex max-w-md flex-col items-center gap-5 text-center"
        style={{ "--enter-delay": "60ms" } as CSSProperties}
      >
        <ManateeMark animate className="h-14 text-text-tertiary" />
        <div>
          <p className="font-display text-2xl text-text-secondary">{title}</p>
          {description !== undefined && description !== "" && (
            <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-text-tertiary">
              {description}
            </p>
          )}
          {milestone !== undefined && milestone !== "" && (
            <span className="mt-4 inline-block rounded-full border border-border bg-bg-elevated px-3 py-1 text-xs text-text-tertiary">
              Arrives in {milestone}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
